'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasr';
var iconName = 'cherries';
var width = 576;
var height = 512;
var aliases = [];
var unicode = 'e0ec';
var svgPathData = 'M261.9 0L172.1 209.5c-17.4-11.1-38-17.5-60.1-17.5-61.9 0-112 50.1-112 112 0 97.2 86 176 192 176s192-78.8 192-176c0-61.9-50.1-112-112-112-15.6 0-30.5 3.2-44 9L292.8 49.8 407.3 218.5c7 11 12.6 22.9 16.8 35.5 11-8.8 24.8-14 40-14 35.3 0 64 28.7 64 64 0 65.4-57.9 125.4-138.8 127.9-12.5 16.7-27.3 31.6-44 44.5 12.5 2.4 25.5 3.6 38.8 3.6 106 0 192-78.8 192-176 0-61.9-50.1-112-112-112-5.4 0-10.7 .4-15.9 1.1L317 0 261.9 0zM157.7 259.2l34.3 35 34.3-35c11.7-11.9 27.8-19.2 45.7-19.2 35.3 0 64 28.7 64 64 0 66.8-60.5 128-144 128S48 370.8 48 304c0-35.3 28.7-64 64-64 17.9 0 34 7.3 45.7 19.2z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCherries = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;